import "moment/locale/id";
import { Route, Routes } from "react-router-dom";
import Loadable from 'react-loadable';
import PageLoader from "components/PageLoader";

const LazyVoucher = Loadable({
    loader: () => import("pages/Voucher/index"),
    loading: () => <PageLoader />,
});

const LazyVoucherForm = Loadable({
    loader: () => import("pages/VoucherForm/index"),
    loading: () => <PageLoader />,
});


function VoucherRoute() {
    return (
        <Routes>
            <Route path="/" element={<LazyVoucher />} />
            <Route path="/new" element={<LazyVoucherForm type="new" />} />
            <Route path="/edit/:voucher_id" element={<LazyVoucherForm type="edit" />} />
        </Routes>
    );
}

export default VoucherRoute;
